import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes';
import Middleware from '@/router/middleware/index';
import { useAuthContext } from '@/context/AuthContext';

/**
 * Middleware that checks if the company admin account is enabled
 * Redirects to company login if account is disabled
 */
const AuthCompanyEnabled: FC = () => {
  const { session, isLoading } = useAuthContext();

  // Check if account is not disabled
  const isEnabled = !session?.user?.user_metadata?.disabled;

  return (
    <Middleware isLoading={isLoading}>
      {isEnabled ? <Outlet /> : <Navigate to={Routes.COMPANY__LOGIN} />}
    </Middleware>
  );
};

export default AuthCompanyEnabled;

